import {
  MenuItem,
  Select,
  CircularProgress,
  Grid,
  Typography,
  Autocomplete,
  TextField,
  IconButton,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { getVendorDetail } from "../../actions";
import { makeStyles } from "@material-ui/styles";
import { CleanHands } from "@material-ui/icons";
import { dashboardStyle } from "../../Components/InvoiceDetails/style";
const useStyles = makeStyles(dashboardStyle);
function VendorCode({
  // disabled,
  // formState,
  // changeHandler,
  // user,
  // vendorCodeOnly,
  // index,
  // bordered,
  // setvendorblock,
  // setErrAlertMessage,
  disabled,
  setFormState,
  formState,
  changeHandler,
  bordered,
  user,
  setvendorblock,
  setErrAlertMessage,
  index,
  onBlur
}) {
  const [vendorCode, setVendorCode] = useState([]);
  const [loading, setLoading] = useState(false);
  const [labelVenodr, setLabelVenodr] = useState("");

  // const autocompleteChangeHandler = (name, value) => {
  //   setFormState((formState) => ({
  //     ...formState,
  //     [name]: value,
  //   }));
  // };

  const getVendorData = async () => {
    getVendorDetail(user, setVendorCode, setLoading);
  };

  useEffect(() => {
    getVendorData();
  }, [user]);
  const classes = useStyles();
  return (
    <Autocomplete
      sx={{
        "& .MuiInputBase-root": {
          height: "30px",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiInputBase-input": {
          marginTop: "-5px", // Adjust this value to move the text up
          fontSize: 15
        },
      }}
      id="Vendor"
      options={vendorCode}
      classes={{ option: classes.option }}
      size="small"
      name="Vendor"
      disabled={disabled}
      value={formState?.vendor_Code}
      // value={{
      //   Vendor_Code: formState?.vendor_Code || "",
      //   Vendor_Name:
      //     vendorCode?.find((x) => x?.Vendor_Code === formState?.vendor_Code)
      //       ?.Vendor_Name || "",
      // }}
      // getOptionLabel={(option) =>
      //   (option !== "" &&
      //     `${`${option?.Vendor_Code}`} ${option?.Vendor_Name ? "-" : ""} ${
      //       option?.Vendor_Name
      //     }`) ||
      //   ""
      // }
      getOptionLabel={(option) => {
        const isBlocked = option?.ALL_COMPANY_CODE === "X";
        return (
          (option !== "" &&
            `${`${option?.Vendor_Code}`} ${option?.Vendor_Name ? "-" : ""} ${option?.Vendor_Name
            }
            ${isBlocked ? "(Blocked)" : ""}
            `) ||
          ""
        );
      }}
      loading={loading}
      onChange={(e, newValue) => {
        let objVendor = {
          target: { name: "vendor_Code", value: newValue },
        };
        changeHandler(objVendor, index);
        if (newValue?.ALL_COMPANY_CODE === "X" && newValue != null) {
          setvendorblock(true);
          setErrAlertMessage("This Vendor code has been Blocked");
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          name=""
          required
          disabled={disabled}
          value={""}
          sx={{
            input: { color: "black !important" },
          }}

          label={
            labelVenodr === "" &&
              (formState?.vendor_Code == "" || formState?.vendor_Code == null)
              ? "Select a Value"
              : ""
          }
          InputLabelProps={{
            style: {
              fontSize: 15, // Adjust this value to decrease the font size
              marginTop: "-5px", // Adjust this value to move the label up
            }, shrink: false, required: false
          }}
          // placeholder="Select a Value"
          onChange={(event) => {
            getVendorDetail(event.target.value, setVendorCode, setLoading);
            setLabelVenodr(event.target.value);
          }}
          variant={`${bordered ? "outlined" : "standard"}`}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>
            ),
          }}
          onBlur={onBlur}
        />
      )}
    />
  );
}

export default React.memo(VendorCode);
